
import {
	IconButton,
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Tooltip,
} from 'components/mui';
import AvatarBadge from './AvatarBadge';
import UserMenu from './UserMenu';
import ListSubheader from '@mui/material/ListSubheader';
import { ChevronLeftIcon, ChevronRightIcon } from 'components/icons';
import styles from '../styles/cantab.module.css';
import React, { useState, useEffect } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { setHomeTourProfileMenuCloser } from 'components/onboarding/tour/homeTourState';

/**
 * @component CanTabHeader
 * @param {Object} props
 * @param {boolean} props.open
 * @param {CanTabUser} props.user
 * @param {function} props.onClick
 * @returns {JSX.Element}
 */
function CanTabHeader({ open, user, onClick }) {
	const [anchorEl, setAnchorEl] = useState(null);

	const openMenu = Boolean(anchorEl);

	const onOpen = (event) => setAnchorEl(event.currentTarget);

	const onClose = () => setAnchorEl(null);

	// Let the CANapps Home Tour close this dropdown when it advances past the
	// profile-menu step. setAnchorEl is stable, so register once.
	useEffect(() => {
		setHomeTourProfileMenuCloser(() => setAnchorEl(null));
		return () => setHomeTourProfileMenuCloser(null);
	}, []);

	return (
		<ListSubheader className={styles.hd_header}>
			<Tooltip title={!open ? 'Open' : 'Close'}>
				<IconButton
					onClick={onClick}
					className={styles.iconColor}
					data-tour="nav-sidebar-toggle"
				>
					{!open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
				</IconButton>
			</Tooltip>
			<ListItemButton
				className={styles.hd_item_btn}
				onClick={onOpen}
				data-tour="nav-profile"
			>
				<ListItemIcon className={styles.hd_item_icon}>
					<AvatarBadge user={user} />
				</ListItemIcon>
				<ListItemText className={styles.hd_item_text} primary={open ? user.username : ''} />
			</ListItemButton>
			<UserMenu openMenu={openMenu} anchorEl={anchorEl} onClose={onClose} />
		</ListSubheader>
	);
}

CanTabHeader.propTypes = {
	open: bool,
	user: shape({ id: string, username: string, strAva: string }),
	onClick: func,
};

export default CanTabHeader;
